import {
  DropDownList,
  DropDownListChangeEvent,
} from "@progress/kendo-react-dropdowns";
// import { promises } from "dns";
import React, { Fragment, useEffect, useState } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../Core/store.hooks";
import { fetchPSTCustomerList } from "./PSTSlice";
import {
  getPSTCustomerListSelector,
  loadingPSTCustomerListSelector,
} from "./PSTSlice";
import CustomerGrid from "./PSTCustomerGrid";

interface SearchGridWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: SearchGridWidgetProps) => {
  const dispatch = useAppDispatch();

  const customerListLoading = useSelector(loadingPSTCustomerListSelector);
  const customerList = useSelector(getPSTCustomerListSelector);

  useEffect(() => {
    //console.log("pst start");
    dispatch<any>(fetchPSTCustomerList());
  }, []);

  useEffect(() => {}, [customerListLoading]);

  if (customerListLoading == "pending" || customerListLoading == undefined) {
    return <Spinner text="customer list" />;
  }
  if (customerListLoading === "rejected" || customerList.length === 0) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"No data found"}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  return (
    //<div style={{padding:"10px"} }>
    //    <h5>Recently selected customers</h5>
    //    <CustomerGrid data={recentCustomerList} recent={true} />
    //    <br/>
    //    <h5>Customer List</h5>
    <CustomerGrid data={customerList} />
    /* </div>*/
  );
};

export default SearchGridWidget;
